class n {
  constructor(t) {
    if (this.config = t, this.translations = {}, !t || n.instance) return n.instance;
    n.instance = this, this.fetchLocale(this.config.locale).then(() => this.switchLocale(this.config.locale));
  }
  /**
   * Fetches translations for the given locale.
   * @param {string} [locale] - The locale identifier (e.g., 'en', 'pl').
   */
  async fetchLocale(t) {
    this.translations[t] = await fetch(`${this.config.path}/${t}.json`).then(s => s.json()).catch(() => null);
  }
  /**
   * Switches to the given locale.
   * @param {string} [locale] - The locale identifier (e.g., 'en', 'pl').
   */
  switchLocale(t) {
    this.locale = t, document.dispatchEvent(new Event("chr-localization-changed"));
  }
  /**
   * Translates a given key using the loaded translations for the current locale.
   *
   * @param {string} key - The key to translate.
   * @returns {string} The translated string if available, otherwise the key itself.
   */
  translate(t) {
    return this.translations[this.locale] ? this.translations[this.locale][t] : t;
  }
}
const a = i => {
  window && (window.__CHR_LOCALIZATION__ || (window.__CHR_LOCALIZATION__ = new n(i), window.getLocalization = () => window.__CHR_LOCALIZATION__));
};
export { n as ChrLocalization, a as registerLocalization };